import ChatPageLayout from "./features";

// Export routes configuration for AppRoutes
export const chatsRoutes = {
  chatsDashboard: {
    path: "/chats",
    component: () => <ChatPageLayout />,
  },
};

// Default export for direct usage
export default ChatPageLayout;
